export class CometChatUtilityConstants {
  static TextFormatter = Object.freeze({
     KEY_UP_DEBOUNCE_TIME: 300,
  })

  static MentionsTextFormatter = Object.freeze({
    MENTIONS_LIMIT: 10,
    MENTIONS_HOVER_TIMEOUT: 500
 })
}